import React from 'react'
import { motion } from "framer-motion"
import { KeyboardArrowRight } from '@mui/icons-material'
import "./nextbutton.css"
const NextButton = () => {
  return (
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 1.3, delay: 3.3, ease: "easeOut"}}
            className="nextButton-container"
        >
            <motion.button className="nextButton"
                whileHover={{scale: [1, 1.1, 1], transition: { repeat: Infinity, duration: 0.5}}}
                >
                <span>next page</span>
                <KeyboardArrowRight className="next-icon"/>
            </motion.button>
        </motion.div>
  )
}

export default NextButton